module.exports = __webpack_public_path__ + "static/media/delishop_app_qrcode.06c399fe.jpg";